// TODO: move to preview folder, detach from kendo etc ...
import '@kendo/kendo.core';
import { Observable } from "../nav";
import 'promise-polyfill/src/polyfill'; // needed for IE11  + NAV Windows Client
import { IExternalPreview, IExternalView, IUndockedViewProxy, IUndockedPreviewProxy } from "./preview.shared";
import { IPreviewSettings, IWebVersion } from "../interfaces";
import { IRawWindowBounds, IWindowBounds, GetWindowOpenBounds, GetWindowBounds, HasWindowBoundsChanged } from "../infoma.environment";
import { fn } from '@common/utils';

export const ExternalPreview_Identifier = "ExternalPreview";
let lastNo = 0;
/** External Visualization */
export class ExternalView<TUndockedProxy extends IUndockedViewProxy = IUndockedViewProxy> extends Observable implements IExternalView {
    public static EVENT_CLOSE = "EXTERNAL_CLOSE";
    public static EVENT_BOUNDSCHANGED = "EXTERNAL_BOUNDSCHANGED";
    public readonly CurrNo = ++lastNo;
    constructor(
        /** Unique Identifier for Item, for master slave communication*/
        public readonly Identifier: string,
        private getUrl: () => string,
        public ExternalCaption?: string) {
        super();
        this.Identifier = Identifier || fn.id(10);
    }

    /** IExternalPreview.Alive */
    public get Alive(): boolean {
        try {
            return this.undockPopup && !this.undockPopup.closed;
        } catch {
            return false;
        }
    }

    /** IExternalPreview.OnPreviewClose */
    OnPreviewClose(bounds: IRawWindowBounds, id: number): void {
        if (bounds) {
            this.UpdateUndockPosition(bounds);
        }
        if (!id || (id == this.CurrNo)) {
            this.IsActive = false;
            if (!this.getUndocked()) {
                this.undockPopup = undefined;
            }
        }
    }

    /** IExternalPreview.OnPreviewClose */
    OnWindowBoundsChanged(bounds: IRawWindowBounds) {
        if (bounds) {
            this.UpdateUndockPosition(bounds);
        }
    }

    get IsActive() {
        return this.isActive;
    }

    set IsActive(val: boolean) {
        if (this.isActive !== val) {
            this.isActive = val;
            if (!val) {
                this.trigger(ExternalPreview.EVENT_CLOSE);
                const ext = this.getUndocked();
                if (ext) {
                    ext.Close(this.CurrNo);
                }
            }
        }
    }
    private isActive: boolean = false;

    public getUndocked() {
        try {
            var proxy = this.undockedProxy;
            if (proxy && proxy.Alive) {
                return proxy;
            }
        } catch (err) {
            delete this.undockedProxy;
        }
    }
    protected undockedProxy: TUndockedProxy;

    protected _lastRawWindowBounds: IRawWindowBounds;

    /** Update the current undocked dock position and dimension settings */
    public UpdateUndockPosition(rawWindowBounds: IRawWindowBounds) {
        // Only update position on changes
        var hasChanged = HasWindowBoundsChanged(rawWindowBounds, jQuery.extend(true, {}, this._lastRawWindowBounds));
        if (hasChanged) {
            // Clone Obj as living in Other window ...
            rawWindowBounds = JSON.parse(JSON.stringify(rawWindowBounds));
            var windowBounds = GetWindowBounds(rawWindowBounds);
            if (windowBounds) { //not set if currently minimized
                this._lastRawWindowBounds = rawWindowBounds;
                this.trigger(ExternalPreview.EVENT_BOUNDSCHANGED, {
                    IsDocked: false,
                    Offset: { left: windowBounds.x, top: windowBounds.y },
                    Size: { width: windowBounds.width, height: windowBounds.height }
                });
            }
        }
    }

    public get Window() {
        try {
            return this.undockPopup && !this.undockPopup.closed && this.undockPopup;
        } catch (err) {
        }
    }

    protected undockPopup: Window;

    public EnsureAlive(windowBounds?: IWindowBounds) {
        if (this.waitAlive) {
            return this.waitAlive;
        }
        let resolve, reject: Function;
        var result = new Promise<TUndockedProxy>((_resolve, _reject) => {
            resolve = _resolve;
            reject = _reject;
        });

        try {
            result.then(() => {
                delete this.waitAlive;
            }, err => {
                delete this.waitAlive;
            });

            if (!this.IsActive) {
                reject("EnsureAlive: Not Active");
                return result;
            }
            if (this.Alive && this.undockedProxy) {
                resolve(this.undockedProxy);
                return this.waitAlive = result;
            }

            const lBounds = this._lastRawWindowBounds;
            windowBounds = (lBounds &&
                { height: lBounds.ContentHeight, width: lBounds.ContentWidth, x: lBounds.WindowX, y: lBounds.WindowY })
                || windowBounds
                || { x: 0, y: 0, height: 500, width: 300 };
            var origBounds = fn.clone(windowBounds);
            // Negative offset not allowed by specs and not supported by IE. So move window instead when loaded.
            // Get browser dependent window.open() parameter window bounds
            windowBounds = GetWindowOpenBounds(windowBounds || {
                x: Math.max(windowBounds.x, 0),
                y: Math.max(windowBounds.y, 0),
                width: Math.max(windowBounds.width, 100),
                height: Math.max(windowBounds.height, 100)
            });

            // Get window.open() params
            var widthProp = windowBounds.width > 0 ? "width=" + windowBounds.width : "";
            var heightProp = windowBounds.height > 0 ? ",height=" + windowBounds.height : "";
            var offsetXProp = ",left=" + windowBounds.x;
            var offsetYProp = ",top=" + windowBounds.y;
            var popupParams = widthProp + heightProp + offsetXProp + offsetYProp +
                ",resizable=yes,toolbar=no,status=no,menubar=no,location=no";

            // Teardown in IE fails ... wOut reset only first popup cycle successfull...
            // Error:"Der Remoteservercomputer ist existiert nicht oder ist nicht verfügbar"
            if (window.UndockedViewProxies) {
                try {
                    delete window.UndockedViewProxies[this.Identifier];
                } catch (err) {
                    window.UndockedViewProxies = {};
                }
            }

            var popup = this.undockPopup = window.open("", "_blank", popupParams);
            if (!popup) {
                throw new Error('Ein Fenster konnte nicht geöffnet werden. Bitte überprüfen sie die Popupblocker- Einstellungen Ihres Browsers');
            }

            let targetUrl = this.getUrl();
            popup.location.assign(targetUrl);

            var UndockedCallbacks = window.UndockedCallbacks || (window.UndockedCallbacks = {});
            UndockedCallbacks[this.Identifier] = this;

            var timedout = false;
            window.setTimeout(() => timedout = true, 10000);
            var waitLoad = window.setInterval(() => {
                try {
                    var undockedProxy = popup.UndockedViewProxies && popup.UndockedViewProxies[this.Identifier] as TUndockedProxy;
                    if (undockedProxy && !undockedProxy.Alive)
                        throw new Error();
                } catch (err) {
                    // Erlaubnis Veweigert?
                    clearInterval(waitLoad);
                    reject(err);
                    return;
                }
                if (undockedProxy) {
                    // Adjust Negative Offset
                    if (origBounds.x < 0 || origBounds.y < 0) {
                        popup.moveBy(Math.min(origBounds.x, 0), Math.min(origBounds.y, 0));
                    }

                    clearInterval(waitLoad);
                    this.undockedProxy = undockedProxy;
                    resolve(this.undockedProxy);
                } else if (timedout) {
                    clearInterval(waitLoad);
                    reject("Die Kommunikation zur exteren Ansicht konnte nicht erfolgreich hergestellt werden!");
                }
            }, 10);

            popup.focus();
        } catch (err) {
            reject(err);
        }
        return this.waitAlive = result;
    }
    private waitAlive: PromiseLike<TUndockedProxy>;

    public EnsureClosed() {
        const undockedWindow = this.Window;
        if (undockedWindow) {
            undockedWindow.close();
            this.trigger(ExternalPreview.EVENT_CLOSE);
        }
    }
}

/** Global External Preview Anchor in main context */
export class ExternalPreview extends ExternalView<IUndockedPreviewProxy> implements IExternalPreview {

    constructor(/** IExternalPreview.PreviewSettings */
        public readonly PreviewSettings: IPreviewSettings,
        appVersion: IWebVersion,
    ) {
        super(ExternalPreview_Identifier, getUrl);

        function getUrl(this: void) {
            var previewLocation = "./preview.html";
            // TODO: For some reason in NAv Undocked Szenario gets build relative to Webviert sub - url
            const check = "" + window.location;
            if (check.indexOf('/preview.html') > 0) {
                previewLocation = check.substr(0, check.indexOf('/preview.html')) + "/preview.html";
            }

            // Imp Version Bump
            if (appVersion) {
                previewLocation += "?ver=" + (appVersion.Version || "") + "_" + (appVersion.PatchLevel || "");
            }
            return previewLocation;
        }
    }
}
